import { render } from "./agentsSwitch.vue?vue&type=template&id=0c2bff82&scoped=true"
import script from "./agentsSwitch.vue?vue&type=script&lang=js"
export * from "./agentsSwitch.vue?vue&type=script&lang=js"

import "./agentsSwitch.vue?vue&type=style&index=0&id=0c2bff82&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c2bff82"]])

export default __exports__